module.exports = __webpack_public_path__ + "static/media/sony-wh-1000mx3.94c788d1.jpg";